import React from "react";
import { useTranslation } from "react-i18next";
import { TableHead } from "@mui/material";
import { TableRow, SortableTableHeader } from "@components";

interface AccountProtocolTableHeadProps {
  sortField: string;
  sortDirection: TableSortDirection;
  onSort: (sortByName: string) => void;
}

export const AccountProtocolTableHead = (
  props: AccountProtocolTableHeadProps
) => {
  const { sortField, sortDirection, onSort } = props;

  const { t } = useTranslation();

  const handleClick = (sortByName: string) => {
    onSort(sortByName);
  };

  return (
    <TableHead>
      <TableRow>
        <SortableTableHeader
          isSortable
          text={t("singleAccountPage.protocolTable.headers.valueDate")}
          sortByName="valueDate"
          sortField={sortField}
          sortDirection={sortDirection}
          onClick={handleClick}
        />
        <SortableTableHeader
          isSortable
          text={t("singleAccountPage.protocolTable.headers.bookingInformation")}
          sortByName="purpose"
          sortField={sortField}
          sortDirection={sortDirection}
          onClick={handleClick}
        />
        <SortableTableHeader
          isSortable
          align="right"
          text={t("singleAccountPage.protocolTable.headers.value")}
          sortByName="amount"
          sortField={sortField}
          sortDirection={sortDirection}
          onClick={handleClick}
        />
      </TableRow>
    </TableHead>
  );
};
